import { render, staticRenderFns } from "./customerList.vue?vue&type=template&id=7a64e346&scoped=true"
import script from "./customerList.vue?vue&type=script&lang=js"
export * from "./customerList.vue?vue&type=script&lang=js"
import style0 from "./customerList.vue?vue&type=style&index=0&id=7a64e346&prod&scoped=true&lang=scss"
import style1 from "./customerList.vue?vue&type=style&index=1&id=7a64e346&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a64e346",
  null
  
)

export default component.exports